import Vue from 'vue';
// import { getData } from '../../utils/storage'
import { toUpperCaseNumber } from '../../utils/unit-conversion';
export default Vue.extend({
    name: 'loanAgreement',
    data: function () {
        return {
            agreementData: {},
            date: new Date(),
        };
    },
    computed: {
        loanMoney: function () {
            return toUpperCaseNumber(this.$route.query.m);
        },
    },
    created: function () {
        // this.agreementData = getData('agreement')
        this.getAgreementMsg();
    },
    methods: {
        // changeDate (value) {
        //   const date = this.agreementData[value].split("-")
        //   return date[0] + "年" + date[1] + "月" + date[2] + "日"
        // },
        getAgreementMsg: function (applicationCode) {
            var _this = this;
            this.$request({
                method: 'post',
                url: '/proxy/api/application/contract/info',
                data: { applicationCode: applicationCode },
            }).then(function (res) {
                if (!res)
                    return;
                if (res && !res.errorCode) {
                    _this.agreementData = res.data;
                }
            });
        },
    },
});
